"use client";

import { Badge } from "@devhop/ui";
import type { WarehouseLayoutFloorRef } from "../api/client";

type Props = {
  floors?: WarehouseLayoutFloorRef[];
  className?: string;
};

/** Badges showing which layout floor(s) a zone/location is placed on */
export function WarehouseLayoutFloorBadges({ floors, className }: Props) {
  if (!floors || floors.length === 0) {
    return (
      <Badge variant="outline" className={className}>
        {"\u0e8d\u0eb1\u0e87\u0e9a\u0ecd\u0ec8\u0ea2\u0eb9\u0ec8\u0ec0\u0e97\u0eb4\u0e87\u0e9c\u0eb1\u0e87"}
      </Badge>
    );
  }
  return (
    <span
      className={
        className ? `flex flex-wrap gap-1 ${className}` : "flex flex-wrap gap-1"
      }
    >
      {floors.map((f) => (
        <Badge key={f.layoutId} variant="secondary">
          F{f.floorIndex + 1} · {f.name}
        </Badge>
      ))}
    </span>
  );
}
